import data from '../block.json';
import "./frontend.scss"

const initializeBlock = (block) => {

    let blockInstance = block;

    if (window.acf) {

        blockInstance = block[0];
    }

    let tabTopStories = blockInstance.querySelector('.top-stories');
    let tabLatestStories = blockInstance.querySelector('.latest-stories');

    tabTopStories.addEventListener('click', () => {enableTab('top-stories', blockInstance)});
    tabLatestStories.addEventListener('click', () => {enableTab('latest-stories', blockInstance)});

    console.log("Top Selected Stories", block.id);

}

const enableTab = (tab, blockInstance) => {
    let tabTopStories = blockInstance.querySelector('.top-stories');
    let tabLatestStories = blockInstance.querySelector('.latest-stories');
    let tabTopStoriesContent = blockInstance.querySelector('.content-top-stories');
    let tabLatestStoriesContent = blockInstance.querySelector('.content-latest-stories');
    console.log('Hello', tab, tabTopStories);
    if (tab === 'latest-stories') {
        tabTopStories.classList.remove("is-active");
        tabLatestStories.classList.add("is-active");
        tabTopStoriesContent.classList.remove("is-active");
        tabLatestStoriesContent.classList.add("is-active");
    }else{
        tabTopStories.classList.add("is-active");
        tabLatestStories.classList.remove("is-active");
        tabTopStoriesContent.classList.add("is-active");
        tabLatestStoriesContent.classList.remove("is-active");
    }

}

const init = () => {
    const {name} = data;

    if (window.acf) {
        window.acf.addAction(`render_block_preview/type=${name}`, initializeBlock);

    } else {
        let blocksOfTypes = document.querySelectorAll('.top-stories-widget');
        blocksOfTypes.forEach(e => {
            initializeBlock(e);
        });
    }

};

if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    init();
} else {
    document.addEventListener('DOMContentLoaded', init);
}


